import useApi, { Model, Query } from "../common/hooks/useApi"

export interface Rol extends Model
{
    Nombre:string
    Permisos:string[]
}



export default ()  => {
    const api = useApi({module:"Rol"});
    
    return {
        list:(query:Query)=>api.list!<Rol>(query),
        save:(data:Partial<Rol>)=>api.save!<Partial<Rol>,Rol>(data),
        delete:(id:number)=>api.delete(id)
    };
}